import React from 'react';

import { Box, Typography, Button, IconButton } from '@mui/material';

import { ReactComponent as CancelIconBlue } from '../../../common/assets/icons/cancel_icon_blue.svg';

import FiltersContainerCell from './FiltersContainerCell';

type Props = {
  onClickClose: () => void;
  onClickApply: () => void;
  onClickCancelAll: () => void;
};

const FiltersContainer: React.FC<Props> = ({
  onClickClose,
  onClickApply,
  onClickCancelAll,
}) => {
  return (
    <Box
      sx={{
        maxWidth: '575px',
        minHeight: '455px',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        borderRadius: '15px',
        padding: '30px',
        flexDirection: 'column',
      }}
    >
      <IconButton
        onClick={onClickClose}
        sx={{ alignSelf: 'flex-start', justifySelf: 'right' }}
      >
        <CancelIconBlue />
      </IconButton>
      <Typography
        sx={{ alignSelf: 'center' }}
        color='text.primary'
        variant='h5'
      >
        Filters
      </Typography>
      <FiltersContainerCell type='include' />
      <FiltersContainerCell type='exclude' />
      <Box
        sx={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'center',
          display: 'flex',
          marginTop: '20px',
        }}
      >
        <Button
          onClick={() => {
            // clearItems();
            onClickCancelAll();
            onClickClose();
          }}
          disableElevation
          color='appGray2'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
            marginRight: '15px',
          }}
        >
          <Typography color='white'>Cancel All</Typography>
        </Button>
        <Button
          onClick={() => {
            onClickClose();
            onClickApply();
          }}
          disableElevation
          color='primary'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
          }}
        >
          <Typography color='white'>Apply</Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default FiltersContainer;
